module.exports = __webpack_public_path__ + "img/7ac642e28c035e1facde79213bf9f2b5.png"


//////////////////
// WEBPACK FOOTER
// ./app/images/keys/backspace.png
// module id = 484
// module chunks = 0